// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3RA8R","input":"styles_input__25ltB"};